import React, { useMemo, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleTaskDetails = () => {
    const { taskId } = useParams();
    const decodedId = taskId ? atob(taskId) : taskId;
    const id = decodedId.replace(/\D/g, '');
    const navigate = useNavigate();
    const { showToast } = useContext(ToastContext);

    const [showDelete, setShowDelete] = useState(false);

    const url = id ? `${API_DOMAIN}${API_ROUTES.task}${id}/` : null;
    const { data: taskDetails, loading } = useDetailFetch(url);

    const columns = useMemo(() => {
        if (!taskDetails) return null;
        const excludedColumns = ['id', 'updated_at', 'created_at'];
        return Object.keys(taskDetails)
            .filter(column => !excludedColumns.includes(column))
            .map((column) => ({
                label: column.charAt(0).toUpperCase() + column.slice(1),
                field: column,
            }));
    }, [taskDetails]);

    const handleDelete = async () => {
        try {
            await axios.delete(`${API_DOMAIN}${API_ROUTES.task}${id}/`, { headers });
            showToast('Task deleted successfully', 'success');
            navigate('/tasks/list');
        } catch (error) {
            console.error('Error deleting task:', error);
            showToast('Error deleting task', 'error');
        }
    };

    return (
        <div>
            <SingleItemDetailTemplate
                details={taskDetails}
                columns={columns}
                loading={loading}
                entityName="Task"
                listPath="/tasks/list"
                editPath={`/task/input/${btoa(id)}`}
                onDelete={() => setShowDelete(true)}
            />
            <ConfirmModal
                isOpen={showDelete}
                onConfirm={handleDelete}
                onCancel={() => setShowDelete(false)}
                title="Delete Task"
                message="Are you sure you want to delete this task? This action cannot be undone."
            />
        </div>
    );
};

export default SingleTaskDetails;
